export default {
  adminMetadata: {
    generalRegistry: 'Общий реестр',
    registerOfCompetencies: 'Реестр компетенций',
    registerOfOpenQuestions: 'Реестр открытых вопросов',
    openQuestionsSettings: 'Настройки открытых вопросов',
    addingOpenQuestions: 'Добавление открытых вопросов',
    fixVersion: 'Зафиксировать версию?',
    selectCompany: 'Выберите компанию',
    buttons: {
      addSection: 'Добавить раздел',
      addOpenQuestion: 'Добавить вопрос',
      addSkillBlock: 'Добавить блок',
      addSkill: 'Добавить компетенцию',
      addOpenQuestions: 'Добавить открытые вопросы',
      addQuestion: 'Добавить индикатор',
      addQuestions: 'Добавить индикаторы',
      addMaterials: 'Добавить материалы',
      uploadOpenQuestions: 'Загрузить вопросы',
      editLevels: 'Редактировать уровни',
      scale: 'Шкала',
      editHints: 'Редактировать подсказки',
      profile: 'Профиль руководителя',
      addSpec: 'Добавить специализацию',
      editSpec: 'Редактировать специализацию',
      deleteSpec: 'Удалить специализацию',
      changePulseSpec: 'Пульс-специализация',
      fix: 'Да, зафиксировать',
    },
    stubs: {
      noVersion: 'Чтобы добавить блок, необходимо зафиксировать версию',
      selectCompany: 'Выберите компанию',
      noVersionSpec: 'Чтобы добавить специализацию, необходимо зафиксировать версию',
      noSkills: 'Чтобы выбрать индикаторы, необходимо добавить блоки и компетенции',
      noMaterials: 'Без материалов',
      noQuestions: 'Для данной специализации отсутствуют индикаторы',
      noSpecs: 'В вашей компании ещё нет специализаций, нажмите на кнопку «Добавить» чтобы создать',
    },
    subtitles: {
      spec: 'К профилю',
      skill_block: 'К блоку компетенций',
      skill: 'К компетенции',
    },
    labels: {
      skill_block: 'Блок компетенций с таким названием уже создан',
      skill: 'Компетенция с таким названием уже создана',
      skill_question: 'Индикатор с таким названием уже создан',
      min: 'Нижний показатель нормы',
      max: 'Верхний показатель нормы',
    },
    emptyBlock: {
      title: 'Выберите<br> специализацию',
      description: 'Чтобы управлять блоками,<br> компетенциями и индикаторами в ней',
    },
    tooltips: {
      materials:
        'Материалы для формирования плана развития, но если материалы не добавлены, план развития можно наполнить в ручную позднее',
      scale: 'Настройка шкалы',
      deleteSkillBlock: 'Удалить блок компетенций',
      deleteSkill: 'Удалить компетенцию',
      deleteQuestion: 'Удалить индикатор',
      skill_block: 'Формулировка изменится во всех специализациях, содержащих блок компетенций.',
      skill: 'Формулировка изменится во всех специализациях, содержащих компетенцию.',
      skill_question: 'Формулировка изменится во всех специализациях, содержащих индикатор.',
      high: 'Компетенция проявляется постоянно и позволяет сотруднику успешно решать задачи',
      middle: 'Компетенция проявляется ограничено и применяется в стандартных ситуациях',
      low: 'Компетенция проявляется в ограниченном объеме/нерегулярно',
      zero: 'Не проявляет компетенцию, не понимает её важности',
      competenciesArea:
        'Зона компетентности - это заданные значения минимально рекомендуемого и целевого уровней, которые являются эталонными требованиями к уровню компетенций, навыкам и опыту, рекомендуемые для выполнения функций и полномочий в рамках роли (или группы ролей)',
      profile:
        'При нажатии на эту кнопку система порекомендует и автоматически установит эталонные требования к уровню компетенций для управленческих профилей',
      pulse: 'Пульс-специализация',
      active:
        'Активная специализация будет доступна на платформе для назначения оценок 360 и прохождения самооценки. Если чекбокс не установлен, то специализация для оценки будет не доступна',
      devMap:
        'Включает возможность формирование плана развития по выбранной специализации. Чекбокс «Активна» у специализации так же должен быть установлен',
      deleteMaterial: 'Удалить материал',
      editMaterial: 'Редактировать материал',
      grades:
        '<article class="py-2"><p>Определяет уровень материала для развития пользователя, в зависимости от его среднего балла по результатам 360. Материал будет доступен в карте развития по логике:</p><ul><li>уровень сложности 0 = диапазону оценок 0-0,99</li><li>уровень сложности 1 = диапазону оценок 1-1,99</li><li>уровень сложность 2 = диапазону оценок 2 - 2,99</li><li>уровень сложности 3 = оценке 3</li><li>Не выбран ни один уровень сложности = будет показан при любой оценке</li></ul><p class="mt-4">Вы можете привязать один материал сразу к нескольким уровням сложности</p></article>',
      editTooltip: 'Редактировать подсказку',
      editHints: 'Редактировать подсказки и варианты ответов',
      hint: 'Подсказка, которую увидит сотрудник для вариантов ответов при прохождении оценки 360',
      addOpenQuestions: {
        spec: {
          active: 'Вопросы будут отображаться отдельным блоком в конце оценки 360',
          disabled: 'Добавление вопросов доступно только после добавления индикаторов',
        },
        skill_block: 'Добавить открытые вопросы к блоку',
        skill: 'Добавить открытые вопросы к компетенции',
      },
      expertGroups:
        'Вопросы отображаются в зависимости от роли в 360 проходящего анкету опроса и настройки «Кому показывать»',
    },
    deleteBaseProfileItem: {
      title: 'Удаление записей из профиля специализации',
      text: 'Все вложенные элементы будут удалены, вы действительно хотите удалить выбранную запись?',
    },
    chooseQuestions: 'Выбрать индикаторы',
    formLabels: {
      skill_block: 'Блок компетенций',
      skill: 'Компетенция',
      skill_question: 'Индикатор',
      junior: 'Junior',
      middle: 'Middle',
      senior: 'Senior',
      name: 'Название материала',
      href: 'Ссылка',
      type: 'Тип материала',
      grades: 'Уровни',
    },
    deleteSpecTitle: 'Данная специализация будет удалена. Вы уверены?',
    tableHeaders: {
      name: 'Название',
      active: 'Активно',
      devMap: 'ПР',
      materials: 'Материалы',
      actions: 'Действия',
      link: 'Ссылка',
      materialType: 'Тип материала',
      grade: 'Уровень сложности',
      options: 'Варианты ответов',
      tooltip: 'Подсказка',
      expertGroups: 'Кому показывать',
    },
    changeMaterials: {
      title: 'Профиль специализации',
      name: 'Название',
      description: 'Общие материалы для развития по специализации',
    },
    newMaterial: 'Введите название материала',
    newTypeMaterial: 'Обучающий курс',
    newSpec: 'Новая специализация',
    editSpec: 'Редактирование специализации',
    matchSpec: 'Данная специализация уже создана',
    changeMaterialsDevPlan: {
      title: 'Редактирование элемента',
      description: 'Материалы для карты развития',
      elementName: 'Название элемента',
    },
    editHint: 'Редактирование подсказок',
    // messages
    successMessages: {
      fixVersion: 'Версия успешно зафиксирована',
      addOpenQuestions: 'Открытые вопросы успешно добавлены',
      editOpenQuestions: 'Открытые вопросы успешно изменены',
      saveOpenQuestionsSettings: 'Настройки открытых вопросов успешно сохранены',
      deleteOpenQuestions: 'Открытые вопросы успешно удалены',
      moveOpenQuestions: 'Открытые вопросы успешно перемещены',
      addSpecs: 'Специализации успешно добавлены',
      deleteRegistryItem: 'Элементы реестра успешно удалены',
      renameRegistryItem: 'Элемент реестра успешно переименован',
      moveRegistryItem: 'Элемент реестра успешно перемещён',
      deleteSkillQuestions: 'Элементы успешно удалены',
      deleteSkillBlock: 'Блок компетенций успешно удален',
      deleteSkill: 'Компетенция успешно удалена',
      deleteQuestion: 'Индикатор успешно удален',
      copyRegistryItem: 'Элемент реестра успешно скопирован',
      moveBaseProfileTree: {
        skillBlock: 'Блок компетенций успешно перемещён',
        skill: 'Компетенция успешно перемещена',
        question: 'Индикатор успешно перемещён',
      },
      changeIndicators: 'Индикаторы успешно изменены',
      skill_block: 'Формулировка успешно изменена',
      skill: 'Формулировка успешно изменена',
      skill_question: 'Индикатор успешно изменён',
      changeScale: 'Шкала успешно изменена',
      deleteSpec: 'Специализация успешно удалена',
      editSpec: 'Специализация успешно изменена',
      changeMaterials: 'Материалы успешно изменены',
      changePulseSpec: 'Пульс-специализация успешно изменена',
      createSpec: 'Специализация успешно создана',
      saveHint: 'Подсказки успешно сохранены',
    },
    errorMessages: {
      getOpenQuestionsTree: 'Не удалось получить реестр открытых вопросов',
      getOpenQuestionsBySpec: 'Не удалось получить открытые вопросы для специализации',
      addOpenQuestions: 'Не удалось добавить открытые вопросы',
      editOpenQuestions: 'Не удалось изменить открытые вопросы',
      deleteOpenQuestions: 'Не удалось удалить открытые вопросы',
      moveOpenQuestions: 'Не удалось переместить открытые вопросы',
      importOpenQuestions: {
        incorrectTemplate: 'Некорректный шаблон',
        emptyFileSection: 'Не у всех вопросов заполнен «Раздел»',
        alreadyExist: 'Вопросы с таким текстом уже существуют',
        default: 'Не удалось загрузить открытые вопросы',
      },
      fixVersion: 'Не удалось зафиксировать версию',
      currentVersion: 'Не удалось получить версию',
      addSpecs: 'Не удалось добавить специализации',
      updateSkillsVersion: 'Не удалось обновить версию',
      fixateSkillsVersion: 'Не удалось зафиксировать версию',
      deleteRegistryItem: 'Не удалось удалить элементы реестра',
      renameRegistryItem: 'Не удалось переименовать элемент реестра',
      moveRegistryItem: 'Не удалось переместить элемент реестра',
      copyRegistryItem: 'Не удалось скопировать элемент реестра',
      sameParent: 'Нельзя перемещать элементы в рамках одного родителя',
      changeType: 'Перенос с уровня на уровень запрещён',
      deleteSkillQuestions: 'Не удалось удалить элементы',
      deleteSkillBlock: 'Не удалось удалить блок компетенций',
      deleteSkill: 'Не удалось удалить компетенцию',
      deleteQuestion: 'Не удалось удалить индикатор',
      moveBaseProfileTree: {
        skillBlock: 'Не удалось переместить блок компетенций',
        skill: 'Не удалось переместить компетенцию',
        question: 'Не удалось переместить индикатор',
      },
      addQuestions: 'Не удалось добавить индикаторы',
      deleteQuestions: 'Не удалось удалить индикаторы',
      changeName: 'Не удалось изменить формулировку',
      changeGrades: 'Не удалось изменить уровни',
      changeScale: 'Не удалось изменить шкалу',
      deleteSpec: 'Не удалось удалить специализацию',
      editSpec: 'Не удалось изменить специализацию',
      changeMaterials: 'Не удалось изменить материалы',
      changePulseSpec: 'Не удалось изменить пульс-специализацию',
      createSpec: 'Не удалось создать специализацию',
      saveHint: 'Не удалось сохранить подсказки',
    },
    // confirm dialogs
    confirmDeleteRegistryItem: {
      title: 'Удалить элемент из реестра?',
      text: 'Отменить данное действие будет невозможно',
      section: {
        title: 'Удалить раздел открытых вопросов?',
        text: 'Раздел будет удалён только из реестра. В профилях специализаций, в которые он был включён ранее, раздел сохранится.',
      },
      question: {
        title: 'Удалить открытый вопрос?',
        text: 'Вопрос будет удалён только из реестра. В профилях специализаций, в которые он был включён ранее, вопрос сохранится.',
      },
    },
    confirmDeleteRegistryItems: {
      title: 'Удалить элементы из реестра?',
      text: 'Отменить данное действие будет невозможно',
      openQuestionsText:
        'Элементы будут удалены только из реестра. В профилях специализаций, в которые они были включены ранее, элементы сохранятся.',
    },
    confirmMoveRegistryItem: {
      title: 'Переместить элемент?',
      button: 'Да, переместить',
    },
    confirmCopyRegistryItem: {
      title: 'Копировать вопрос?',
      text: 'Копия добавится в текущий раздел ниже копируемого вопроса',
      button: 'Да, копировать',
    },
    confirmDeleteMaterial: {
      title: 'Удалить материал?',
      text: 'Отменить данное действие будет невозможно',
    },
    // dialogs
    createRegistryItemDialog: {
      skill_block: {
        title: 'Новые блоки компетенций',
        subtitle: 'Навыки',
        formLabels: {
          name: 'Название блока',
        },
        addButton: 'Добавить ещё один',
        successMessage: 'Блоки компетенций успешно созданы',
        errorMessage: 'Не удалось создать блоки компетенций',
      },
      skill: {
        title: 'Новые компетенции',
        subtitle: 'Блок компетенций',
        formLabels: {
          name: 'Название компетенции',
        },
        addButton: 'Добавить ещё одну',
        successMessage: 'Компетенции успешно созданы',
        errorMessage: 'Не удалось создать компетенции',
      },
      skill_question: {
        title: 'Новые индикаторы',
        subtitle: 'Компетенция',
        formLabels: {
          name: 'Название индикатора',
        },
        addButton: 'Добавить ещё один',
        successMessage: 'Индикаторы успешно созданы',
        errorMessage: 'Не удалось создать индикаторы',
      },
      section: {
        title: {
          create: 'Новый раздел открытых вопросов',
          rename: 'Редактирование раздела открытых вопросов',
        },
        formLabels: {
          name: 'Название раздела',
        },
        addButton: 'Добавить ещё один',
        successMessages: {
          create: 'Раздел открытых вопросов успешно создан',
          rename: 'Раздел открытых вопросов успешно изменён',
        },
        errorMessages: {
          create: 'Не удалось создать раздел открытых вопросов',
          rename: 'Не удалось изменить раздел открытых вопросов',
        },
      },
      question: {
        title: {
          create: 'Новый открытый вопрос',
          rename: 'Редактирование открытого вопроса',
        },
        subtitle: 'Раздел вопросов',
        formLabels: {
          name: 'Текст открытого вопроса',
          description: 'Краткое описание или подсказка',
        },
        addButton: 'Добавить ещё один',
        removeButton: 'Удалить вопрос',
        successMessages: {
          create: 'Открытый вопрос успешно создан',
          rename: 'Открытый вопрос успешно изменён',
        },
        errorMessages: {
          create: 'Не удалось создать открытый вопрос',
          rename: 'Не удалось изменить открытый вопрос',
        },
      },
      invalidMessages: {
        skill_block: 'Блок компетенций с таким названием уже создан',
        skill: 'Компетенция с таким названием уже создана',
        skill_question: 'Индикатор с таким названием уже создан',
        section:
          'Раздел открытых вопросов с таким названием уже существует, для сохранения измените название.',
        question: 'Вопрос с таким текстом уже существует, для сохранения измените текст вопроса.',
      },
      infoMessages: {
        section:
          'Раздел изменится только в реестре. В профилях специализаций, в которые он был включён ранее, раздел не изменится.',
        question:
          'Вопрос изменится только в реестре. В профилях специализаций, в которые он был включён ранее, вопрос не изменится.',
      },
    },
    changeRegistryItemDialog: {
      skill_block: 'Редактирование формулировки',
      skill: 'Редактирование формулировки',
      skill_question: 'Редактировать индикатор',
    },
    changeScaleDialog: {
      titles: {
        spec: 'Настройка шкалы',
        question: 'Настройка шкалы индикатора',
      },
      descriptions: {
        spec: 'Определите зону компетентности для профиля должности',
        question: 'Определите зону компетентности для индикатора',
      },
    },
    changeQuestionMetadataDialog: {
      title: 'Редактирование вариантов ответов и подсказок',
      description:
        'Варианты ответов и подсказки к ним, которые увидит сотрудник при прохождении оценки 360',
      table: {
        headers: {
          options: 'Варианты ответов',
          tooltip: 'Подсказка',
          actions: 'Действия',
        },
      },
      confirmSaveDialog: {
        title: 'Сохранить изменения?',
        text: 'Вы действительно хотите изменить варианты ответов и тексты подсказок? Изменения будут применены ко всем индикаторам данного профиля специализации, а также ко всем другим профилям, в которых используются эти индикаторы.',
        button: 'Да, изменить',
      },
      infoMessages: {
        spec: 'Изменения будут применены ко всем индикаторам данного профиля специализации, а также ко всем профилям, в которых используются эти индикаторы.',
      },
      successMessage: 'Изменения успешно сохранены',
      errorMessages: {
        getQuestionTooltips: 'Не удалось получить данные о подсказках',
        getQuestionAnswerTexts: 'Не удалось получить данные об ответах на вопрос',
        getAffectedSpecs: 'Не удалось получить данные о специализациях',
        createQuestionTooltips: 'Не удалось сохранить подсказки',
        createQuestionAnswerTexts: 'Не удалось сохранить варианты ответов',
      },
    },
    //
  },
};
